export default {
  appid: "wx037ce4df6c9a23f8",
  isOrange: 1,
  title: "菲律宾话费充值", // 分享标题
  desc: "支持支付宝,微信付款,24小时随时充值", // 分享描述
  orangLink: "https://ph.mmyqq.com/home", // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
  imgUrl:
    "https://mmm-file.oss-cn-beijing.aliyuncs.com/certificate/2020/03/23/df18028f-1c26-4d76-b29a-f723bcb22216.jpg", // 分享图标
};
